import React, { memo } from "react";
import ModuleTabContent from "components/layout-components/ModuleTabContent";
import { Card } from "antd";
import ModuleSubTabs from "components/layout-components/ModuleSubTabs";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import Accurence from "./Accurence";
import Periodicals from "./Periodicals";
import StatusView from "./StatusView";
import Reports from "./Reports";
import ConsolidateReport from "./ConsolidateReport";
import Dashboard from "./Dashboard";
import PeriodicalConfig from "./PeriodicalConfig";
import PeriodicalScheduling from "./PeriodicalScheduling";

// This module (MajesticERP-PeridicalWeb, nav key "work-scheduler", module_id 2)
// is substantially bigger than Cleaning Audit or Laundry Audit — 10 screens,
// two of which (PeriodicalConfig, PeriodicalScheduling) were drag-and-drop
// UIs (react-dnd) in the old app, rebuilt here as explicit modal actions
// instead (no drag library anywhere in this codebase).
//
// Tab labels/order below match the old app's own top nav exactly (confirmed
// by reading MajesticERP-PeridicalWeb/code/client/src/shared/containers/
// WorkScheduler/index.js's TABS array + web/routes.js directly):
//   Overview -> Dashboard.js            (/dashboard)
//   Periodical Master -> Periodicals.js (/periodical_master)
//   Frequency Master -> Accurence.js    (/accurence_master)
//   Allocation -> PeriodicalConfig.js   (/periodical_configuration)
//   Scheduling -> PeriodicalScheduling.js (/periodical_scheduling)
//   Periodical Report -> Reports.js     (/reports)
//   Status View -> StatusView.js        (/status_view)
// ConsolidateReport (/periodical_status_report) is a real, separately
// routed screen but its own nav entry is commented out in the old TABS
// array — not part of the live menu there either — so it's nested here as
// a second inner tab under "Periodical Report" rather than dropped, since
// the feature and its backend endpoint are both real.
// PeriodicalStatus (/periodical_status) was already confirmed dead/mock
// code and has no TABS entry in the old app either — skipped, as before.
// Tabs (titles/order) are in NavigationConfig's "work-scheduler" entry.
const screens = {
  overview: <Dashboard />,
  "periodical-master": <Periodicals />,
  "frequency-master": <Accurence />,
  allocation: <PeriodicalConfig />,
  scheduling: <PeriodicalScheduling />,
  // Same as Employee Connect: sub-tabs inside the page card, each with its own address.
  "periodical-report": (
    <Card bodyStyle={{ padding: "24px 28px" }}>
      <ModuleSubTabs
        basePath={`${APP_PREFIX_PATH}/work-scheduler/periodical-report`}
        items={[
          { key: "facility-report", label: "Facility Report", render: () => <Reports /> },
          { key: "consolidate-report", label: "Consolidate Report", render: () => <ConsolidateReport /> },
        ]}
      />
    </Card>
  ),
  "status-view": <StatusView />,
};

const WorkScheduler = () => <ModuleTabContent navKey="work-scheduler" screens={screens} />;

export default memo(WorkScheduler);
